import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { clamp as n } from "../utils/clamp.js";
import { isEqual as t } from "../utils/isEqual.js";
var _e = function e(n) {
  var _iterator = _createForOfIteratorHelper(s),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t = _step.value;
      _t.getState() === i.Running && _t.tick(a ? n - a : 0);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  a = n, u = window.requestAnimationFrame(_e);
};
var i, o, r;
!function (n) {
  n[n.Initializing = 0] = "Initializing", n[n.Running = 1] = "Running", n[n.Paused = 2] = "Paused", n[n.Completed = 3] = "Completed", n[n.Destroyed = 4] = "Destroyed";
}(i || (i = {})), function (n) {
  n[n.Spring = 0] = "Spring", n[n.Ease = 1] = "Ease";
}(o || (o = {})), function (n) {
  n[n.Loop = 0] = "Loop", n[n.Reverse = 1] = "Reverse";
}(r || (r = {}));
var s = new Set();
var u = null,
  a = 0;
function c() {
  var a = i.Initializing,
    f = o.Ease,
    l = 0,
    g = 0,
    p = c.Easings.Linear,
    m = 500,
    d = 0,
    b = 0,
    S = 0,
    h = 0,
    y = 1 / 0,
    E = .01,
    R = .01,
    M = !1,
    j = {},
    w = null,
    v = {},
    O = {},
    C = {},
    L = 0,
    I = 0,
    D = r.Loop,
    z = c.Easings.Linear;
  var N = new Map();
  function V(n) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    var _iterator2 = _createForOfIteratorHelper(N.get(n) || []),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;
        e.apply(void 0, t);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  function q(n) {
    return g = 0, n ? w = setTimeout(function () {
      x();
    }, n) : x(), F;
  }
  function x() {
    a = i.Running, V("start", v, O);
  }
  function A() {
    if (a = i.Completed, C = {}, V("end", v), a === i.Completed) if (l < L) {
      if (l++, D === r.Reverse) {
        var _n = Object.assign({}, j);
        j = Object.assign({}, O), O = _n;
      }
      q(I);
    } else l = 0;
    return F;
  }
  var F = {
    getState: function getState() {
      return a;
    },
    easing: function easing(n) {
      return p = n, f = o.Ease, C = {}, F;
    },
    duration: function duration(n) {
      return m = n, F;
    },
    spring: function spring() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      f = o.Spring;
      var t = {
          velocity: 0,
          mass: 1,
          tension: 170,
          friction: 26,
          restDelta: .1,
          restSpeed: .1,
          maxSpeed: 1 / 0,
          clamp: !0
        },
        _Object$assign = Object.assign(Object.assign({}, t), n),
        e = _Object$assign.velocity,
        i = _Object$assign.mass,
        r = _Object$assign.tension,
        s = _Object$assign.friction,
        u = _Object$assign.restDelta,
        a = _Object$assign.restSpeed,
        c = _Object$assign.maxSpeed,
        l = _Object$assign.clamp;
      return d = e, b = i, S = r, h = s, R = u, E = a, y = c, M = l, C = {}, F;
    },
    isRunning: function isRunning() {
      return a === i.Running;
    },
    isSpring: function isSpring() {
      return f === o.Spring;
    },
    from: function from(n) {
      return v = Object.assign({}, n), F;
    },
    to: function to(n) {
      return O = n, F;
    },
    repeat: function repeat(n) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r.Loop;
      var i = arguments.length > 3 ? arguments[3] : undefined;
      return L = n, I = t, D = e, z = i || p, F;
    },
    on: function on(n, t) {
      var e, i;
      return e = n, i = t, N.set(e, [].concat(_toConsumableArray(N.get(e) || []), [i])), F;
    },
    off: function off(n, t) {
      var e, i;
      return e = n, i = t, N.has(e) && N.set(e, N.get(e).filter(function (n) {
        return n !== i;
      })), F;
    },
    start: function start(n) {
      return a = i.Initializing, j = Object.assign({}, v), t(j, O) || (s.add(this), u || (u = window.requestAnimationFrame(_e)), q(n)), F;
    },
    pause: function pause() {
      return w && (clearTimeout(w), w = null), a === i.Running && (a = i.Paused, V("pause", v)), F;
    },
    end: A,
    tick: function tick(e) {
      e > 50 && (e = 50), g += e;
      var s = 0,
        u = !1;
      if (a !== i.Running) return F;
      if (f === o.Ease) {
        s = n(0, g / m, 1), u = 1 === s;
        var _t2 = D === r.Reverse ? z : p;
        for (var _n2 in v) v[_n2] = j[_n2] + (O[_n2] - j[_n2]) * _t2(s);
      }
      if (f === o.Spring) {
        var _t3 = .001 * e;
        var _i = 0;
        for (var _e2 in v) {
          var _o = O[_e2];
          var _r = v[_e2];
          if ("number" != typeof _o || isNaN(_o) || "number" != typeof _r || isNaN(_r)) continue;
          if (Math.abs(_o - _r) <= R) {
            v[_e2] = _o, C[_e2] = 0;
            continue;
          }
          C[_e2] || ("object" == typeof d && "number" == typeof d[_e2] ? C[_e2] = d[_e2] : C[_e2] = "number" == typeof d ? d : 0);
          var _s = C[_e2];
          _s = n(-1 * Math.abs(y), _s, Math.abs(y));
          var _u = _s * b * h;
          _s += ((_r > _o ? -1 : 1) * (Math.abs(_o - _r) * S) - _u) / b * _t3, _r += _s * _t3;
          var _a = v[_e2] > _o ? _r < _o : _r > _o;
          var _c = Math.abs(_s) < E && Math.abs(_o - _r) <= R;
          M && _a && (_c = !0), _c ? (_r = _o, _s = 0) : _i++, v[_e2] = _r, C[_e2] = _s;
        }
        u = !_i;
      }
      var c = Object.assign({}, O);
      return V("step", v, j, O, s), u && a === i.Running && t(O, c) && (a = i.Completed, A()), F;
    },
    getStartValues: function getStartValues() {
      return j;
    },
    getCurrentValues: function getCurrentValues() {
      return v;
    },
    getCurrentVelocities: function getCurrentVelocities() {
      return C;
    },
    getEndValues: function getEndValues() {
      return O;
    },
    destroy: function destroy() {
      a = i.Destroyed, w && (clearTimeout(w), w = null), j = v = O = {}, s.delete(this);
    }
  };
  return F;
}
c.destroy = function () {
  var _iterator3 = _createForOfIteratorHelper(s),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _n3 = _step3.value;
      _n3.destroy();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  u && (cancelAnimationFrame(u), u = null);
}, c.Easings = {
  Linear: function Linear(n) {
    return n;
  },
  EaseIn: function EaseIn(n) {
    return 0 === n ? 0 : Math.pow(2, 10 * n - 10);
  },
  EaseOut: function EaseOut(n) {
    return 1 === n ? 1 : 1 - Math.pow(2, -10 * n);
  },
  EaseInOut: function EaseInOut(n) {
    return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2;
  }
};
export { c as Tween, r as TweenRepeatType, i as TweenState };